import { useEffect, useRef } from 'react'

import { useTheme } from './use-theme'

export { useTheme }

// Returns undefined on the first call
// Then returns the value from the previous call
export const usePrevious = <T>(value: T): T | undefined => {
  const ref = useRef<T>()

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}
